<ng-container *ngIf="!isSiteIntl && clientUse; else fundDetail">
  <ng-container *ngIf="!isInvestor">
    <eds-info-item *ngFor="let info of clientUseValue" [info]="info">
      <ng-container *ngIf="params?.data?.literatureData?.href">
        <div
          edsFlexbox
          alignItems="baseline"
          justifyContent="flex-end"
          class="literature-font"
        >
          <span>{{
            "literature." + params?.data?.literatureData?.clientUse | translate
          }}</span>
          <eds-link-item
            title="{{ 'literature.finra-letter' | translate }}"
            [useSmallText]="true"
            [hasIcon]="true"
            type="new-window"
            hasTarget="false"
            size="small"
            (click)="goToLink(params?.data?.literatureData, $event)"
          ></eds-link-item>
        </div>
      </ng-container>
    </eds-info-item>
  </ng-container>
  <eds-info-item *ngFor="let info of cellvalue" [info]="info"> </eds-info-item>
</ng-container>
<ng-template #fundDetail>
  {{ cellvalue }}
</ng-template>
